import IMask from "imask";

export default class Forms {
    constructor() {
        this.applyMasks();
    }

    static config() {
        return {
            fieldClass: 'error-field',
            disableSubmit: true,
        };
    }

    static messages() {
        return {
            missingValue: {
                checkbox: "Você deve aceitar a política de privacidade.",
                radio: "Por favor selecione um valor.",
                select: "Por favor selecione um valor.",
                "select-multiple": "Por favor selecione pelo menos um valor.",
                text: "Por favor preencha este campo de texto.",
                email: "O e-mail é obrigatório.",
                tel: "O telefone é obrigatório.",
                date: "A data é obrigatória.",
                name: "O nome é obrigatório.",
                default: "Por favor preencha este campo",
                custom: {
                    cnpj: "Informe um CNPJ válido.",
                    cpf: "Informe um CPF válido.",
                    // adicione outros campos aqui se precisar
                }
            },
            patternMismatch: {
                email: "Insira um endereço de e-mail corporativo válido.",
                url: "Informe uma URL.",
                number: "Informe um número válido.",
                tel: "Informe um telefone válido.",
                date: "Por favor utilizar o formato DD/MM/YYYY",
                cpf: "Informe um CPF válido.",
                cnpj: "Informe um CNPJ válido.",
                name: "Informe um nome válido.",
                default: "Por favor, preencha o campo com conteúdo válido.",
            },
            outOfRange: {
                over: "Selecione um valor que não seja superior a {max}.",
                under: "Selecione um valor que não seja inferior a {min}.",
            },
            wrongLength: {
                over: "Reduza este texto para não mais que {maxLength} caracteres. Você está usando atualmente {length} caracteres.",
                under: "Por favor, estenda este texto para {minLength} caracteres ou mais. Você está usando atualmente {length} caracteres.",
            },
            isNotZero: "Por favor selecione uma opção válida.",
        };
    }

    static activeErros(form) {
        const fields = form.querySelectorAll('input, select, textarea');

        fields.forEach(field => {
            const erroCampo = field.parentElement.querySelector('.erro-campo');

            if (field.required) {
                if (field.classList.contains('error-field')) {
                    erroCampo?.classList.remove('hidden');
                } else {
                    erroCampo?.classList.add('hidden');
                }
            }
        });
    }


    applyMasks() {

        console.log('apply masks inicialized')

        document.querySelectorAll(".telMask").forEach(field => {
            IMask(field, { mask: "(00) 00000-0000" });
        });

        document.querySelectorAll(".dateMask").forEach(field => {
            IMask(field, {
                mask: Date,
                pattern: "d/`m/`Y",
                blocks: {
                    d: { mask: IMask.MaskedRange, from: 1, to: 31 },
                    m: { mask: IMask.MaskedRange, from: 1, to: 12 },
                    Y: { mask: IMask.MaskedRange, from: 1900, to: 2099 }
                }
            });
        });

        document.querySelectorAll(".moneyMask").forEach(field => {
            // IMask(field, {
            //     mask: Number,
            //     scale: 2,
            //     signed: false,
            //     thousandsSeparator: ".",
            //     padFractionalZeros: true,
            //     normalizeZeros: true,
            //     radix: ",",
            //     mapToRadix: ["."],
            //     overwrite: true,
            // });
            field.addEventListener('input', (e) => {
                let value = e.target.value.replace(/\D/g, '');
                value = (parseInt(value, 10) / 100).toFixed(2);
                value = value
                    .replace('.', ',')
                    .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
                e.target.value = value;
            });
        });

        document.querySelectorAll(".cpfMask").forEach(field => {
            IMask(field, { mask: "000.000.000-00" });
        });

        document.querySelectorAll(".cnpjMask").forEach(field => {
            IMask(field, { mask: "00.000.000/0000-00" });
        });
    }
}
